import { forwardRef } from 'react'
import { img } from '../../../assets/assets'
import { useCardContent } from '../../../hooks/useCardContent'
import { ICard } from '../../../types/card'

export const CardFile = forwardRef<
    any,
    {
        card: ICard
    }
>(({ card }, ref) => {
    const content = useCardContent(card)
    return content ? (
        content.type === 'IMAGE' ? (
            <img
                src={`https://caliente.app/sha256/${content.sha256}${
                    !content.isOriginal ? ':fullhd' : ''
                }`}
                alt="alt"
                ref={ref}
            />
        ) : (
            <video
                autoPlay
                muted
                loop
                className={
                    card.isUseCensored && !content.isOriginal ? 'blur' : ''
                }
                ref={ref}
            >
                <source
                    src={`https://caliente.app/sha256/${content.sha256}${
                        !content.isOriginal ? ':fullhd' : ''
                    }`}
                    type="video/mp4"
                />
            </video>
        )
    ) : (
        <img src={img.lotImg1} alt="empty lot"></img>
    )
})
